import { FormattedMessage } from "react-intl";
import saveIcon from "../../../assets/buttons/save.svg";
import AlertLevel from "../../../models/alert";
import AlertModal from "../../Shared/AlertModal/AlertModal";

type SingleSaveWarningModalProps = {
  show?: boolean;
  saving?: boolean;
  onSave?: () => void;
  onClose?: () => void;
  selectedActionComponent: JSX.Element | null;
};

const SingleSaveWarningModal = ({
  show,
  saving,
  onSave,
  onClose,
  selectedActionComponent,
}: SingleSaveWarningModalProps) => {
  return (
    <AlertModal
      show={show}
      loading={saving}
      okBtn={{
        text: (
          <b>
            <FormattedMessage
              id="ECG_DETAILS.SINGLE_SAVE.SAVE_CONFIRM"
              defaultMessage="YES SAVE"
            />
          </b>
        ),
        onClick: onSave,
        icon: {
          src: saveIcon,
        },
      }}
      cancelBtn={{
        text: (
          <b>
            <FormattedMessage
              id="ECG_DETAILS.SINGLE_SAVE.CANCEL_SAVE"
              defaultMessage="< BACK TO EDIT"
            />
          </b>
        ),
        onClick: onClose,
      }}
      level={AlertLevel.Warning}
    >
      <p>
        <FormattedMessage
          id="ECG_DETAILS.SINGLE_SAVE.WARNING"
          defaultMessage="Once you save this ECG interpretation, you will not be able to edit its
      details."
        />
        <br />
        {selectedActionComponent && (
          <>
            <hr />
            {selectedActionComponent}
            <hr />
          </>
        )}
        <FormattedMessage
          id="GLOBAL.SAVE_CONFIRM"
          defaultMessage="Are you sure you want to proceed?"
        />
      </p>
    </AlertModal>
  );
};

export default SingleSaveWarningModal;
